import Upsert from '../Upsert/Upsert'
import { NAWSurvey } from '../../../../types/NAW/Survey'
import { frontendDomain, getPrettyDateTime } from '../../../../utility'
import { useSelector } from 'react-redux'
import props from '../../../../redux/props'
import useToast, { Type } from '../../../hooks/useToast'
import { LinkIcon } from '@heroicons/react/24/outline'
import Tooltip from '../../../UI/Tooltip/Tooltip'

type Props = { data: NAWSurvey; pullList: () => void }

const Copy = ({ text }) => {
  const toast = useToast()
  const t = useSelector((s) => s[props.TRANSLATION])

  const copyValue = () => {
    navigator.clipboard.writeText(text)
    toast(t.naw.survey.list.copySuccess, Type.SUCCESS)
  }

  return (
    <div className="btn" onClick={copyValue}>
      <Tooltip text={t.naw.survey.list.copyTooltip}>
        <LinkIcon className="h-[21px]" />
      </Tooltip>
    </div>
  )
}

const Item: React.FC<Props> = ({ data, pullList }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  const getLastInteraction = () => {
    if (data.furthestStep) {
      return getPrettyDateTime(data.updatedOn as unknown as Date)
    } else {
      return '-'
    }
  }

  const getFurthestStep = () => {
    if (data.furthestStep) {
      return t.naw.survey.list.furthestStep[data.furthestStep]
    } else {
      return '-'
    }
  }

  return (
    <div className="cursor-pointer flex w-full items-center gap-2">
      <a className="w-6/12 block hover:underline" target="_blank" rel="noreferrer" href={`/public/naw/${data.uuid}`}>
        {data.name}
      </a>
      <div className="w-2/12">{getLastInteraction()}</div>
      <div className="w-2/12">{getFurthestStep()}</div>
      <div className="w-2/12 flex justify-end items-center gap-3">
        <Upsert initData={data} pullList={pullList} />
        <Copy text={`${frontendDomain}/public/naw/${data.uuid}`} />
      </div>
    </div>
  )
}

export default Item
